(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("open-icons", [], factory);
	else if(typeof exports === 'object')
		exports["open-icons"] = factory();
	else
		root["open-icons"] = factory();
})(self, () => {
return 